import { OnfidoNotRequired } from './not-required';

export default OnfidoNotRequired;
